<template>
<div id="container">

    <div class="row">
        <div class="col-lg-12">
            <contadores />
        </div>
    </div>
    <div class="row">
        <div class="col-lg-12">
            <agentes-conectados :agentesPusher="agentesPusher" :agenteP="agenteP" :cambioEstado="cambioEstado" />
        </div>
        <!--            <div class="col-lg-6">-->
        <!--                <div class="ibox">-->
        <!--                    <div class="ibox-content">-->
        <!--                        <linechart :chartData="chartData" :chartOptions="chartOptions"/>-->
        <!--                    </div>-->
        <!--                </div>-->
        <!--            </div>-->
    </div>
     <div class="row">
        <div class="col-lg-12">
            <interacciones :interaccion="cambioInter" />
        </div>
    </div>
    <hr>
    <Busqueda @search="search" :month="false" />
    <div class="row">
        <div class="col-lg-12">
            <graficos />
        </div>
    </div>

   
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import graficos from './GraficosComponent'
import contadores from './ContadoresComponent'
import agentesConectados from './AgentesConectadosComponent'
import Busqueda from './Busqueda'
import interacciones from './Interacciones/InteraccionesComponent'
export default {
    components: {
        graficos,
        contadores,
        agentesConectados,
        interacciones,
        Busqueda
    },
    props: {
        chartData: {
            type: Object,
            default: null
        },
        chartOptions: {
            type: Object,
            default: null
        }
    },
    created: function () {

    },
    data: function () {
        return {
            agentesPusher: [],
            agenteP: { id: null, added: false },
            cambioEstado: {},
            cambioInter: {},
        }
    },
    mounted() {
        // console.log(Echo)
        // this.renderChart(this.chartData, this.chartOptions)

        Echo.join('colaInteracciones')
            .listen('cambioEstadoAgente', (e) => {
                this.cambioEstado = e
            }).on('pusher:subscription_succeeded', (members) => {
                // console.log("CONECTADO CORRECTAMENTE");
                // console.log(members);
                var miembro = []
                members.each(function (member) {
                    miembro.push(parseInt(member.id))
                })
                this.agentesPusher = miembro
            }).joining((member) => {
                // console.log("NUEVO AGENTE JOINGIN");
                // console.log(member);
                this.actualizaMiembros(parseInt(member.id), true)
                // add_member(member.id, member.info);
            }).leaving((member) => {
                // console.log("EXIT AGENTE leaving");
                // console.log(member);
                this.actualizaMiembros(parseInt(member.id), false)
                //   remove_member(member.id, member.info);
            })
            .listen('nuevaInteraccion', (interaccion) => {
                // this.cambioInter = interaccion.nuevaInteraccion
                // console.log("NUEVA INTERACCION");
                console.log(interaccion);

                this.$store.commit('interacciones/updateInteracciones', interaccion.nuevaInteraccion)
            }).listen('quitarInteraccion', (interaccion) => {
                this.$store.commit('interacciones/updateInteracciones', interaccion.quitarInteraccion)
                // this.cambioInter = interaccion.quitarInteraccion
            });
        // .on('pusher:member_added', (agente) => {
        //     console.log("NUEVO AGENTE");
        //     console.log(agente);
        //     this.actualizaMiembros(parseInt(agente.id), true)
        // }).on('pusher:member_removed', (agente) => {
        //     console.log("AGENTE REMOVE");
        //     this.actualizaMiembros(parseInt(agente.id), false)
        // })

        // Echo.channel('chat')
    },
    methods: {
        search(payload){
            this.$store.commit('graficos/setFechaInicio', payload.date_start)
            this.$store.commit('graficos/setFechaFinal', payload.date_end)
            let data = {
                inicio: payload.date_start,
                final: payload.date_end
            }
            this.$store.dispatch('graficos/getInteracciones', data).then(response => {
                // console.log(response);
                // this.$store.commit('interacciones/setInteracciones',response.data.interacciones);

            })
        },
        actualizaMiembros(agente, added) {
            const existe = this.agentesPusher.findIndex(mems => parseInt(mems) === agente)
            if (added === true && existe === -1) {
                this.agenteP = {
                    id: agente,
                    added: added
                }
                this.agentesPusher.push(agente)
            }
            if (added === false && existe !== -1) {
                this.agenteP = {
                    id: agente,
                    added: added
                }
                this.agentesPusher.splice(existe, 1)
            }
        },
    }
    // computed : {
    //     ...mapGetters({
    //         interacciones: 'inter/getAgentes',
    //     }),
    // }
}
</script>
